import React, { FC } from "react";

import { ButtonProps } from "@atlaskit/button";
import AButton from "@atlaskit/button/loading-button";

export interface IProps extends ButtonProps {
  isLoading?: boolean;
}

export const Button: FC<IProps> = (props) => <AButton {...(props as any)} />;
